import {
	DropdownMenu,
	type DropdownMenuOptions,
	HStack,
	Heading,
	Label,
	Spinner,
	UnstyledIconButton,
	VStack,
} from "@msuite/picasso";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { TbDotsVertical } from "react-icons/tb";

export interface ChartWrapperProps {
	title: string;
	description?: string;
	isLoading: boolean;
	children: React.ReactNode;
	menuItems?: DropdownMenuOptions;
}

export function ChartWrapper({
	description,
	title,
	children,
	isLoading,
	menuItems,
}: ChartWrapperProps) {
	/** Render */
	return (
		<React.Fragment>
			<VStack
				spacing={0}
				py={2}
				px={2.5}
			>
				<HStack justifyContent="space-between">
					<Heading>{title}</Heading>
					{menuItems && (
						<DropdownMenu options={menuItems}>
							<UnstyledIconButton
								size="xs"
								variant="ghost"
								icon={<TbDotsVertical />}
								aria-label="Menü"
							/>
						</DropdownMenu>
					)}
				</HStack>
				{description && <Label>{description}</Label>}
			</VStack>
			<AnimatePresence mode="wait">
				{isLoading ? (
					<motion.div
						key="loading"
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							height: "100%",
							paddingBottom: "10%",
						}}
						initial={initial}
						animate={animate}
						exit={exit}
						transition={transition}
					>
						<Spinner />
						<Label>Daten werden geladen...</Label>
					</motion.div>
				) : (
					<motion.div
						key="content"
						style={{
							display: "flex",
							flex: 1,
						}}
						initial={initial}
						animate={animate}
						exit={exit}
						transition={transition}
					>
						{children}
					</motion.div>
				)}
			</AnimatePresence>
		</React.Fragment>
	);
}

const initial = { opacity: 0 };
const animate = { opacity: 1 };
const exit = { opacity: 0 };
const transition = { duration: 1 };
